// src/components/ExportButton.js
import React from 'react';

function ExportButton({ data, filename, label = 'Export CSV', icon = '📥', variant = 'primary' }) {
  
  const convertToCSV = (data) => {
    if (!data || data.length === 0) return '';
    
    const headers = Object.keys(data[0]);
    
    const rows = data.map(row => 
      headers.map(header => {
        const value = row[header] !== undefined && row[header] !== null ? row[header] : '';
        return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
      }).join(',')
    );
    
    return [headers.join(','), ...rows].join('\n');
  };
  
  const handleExport = () => {
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }
    
    const csv = convertToCSV(data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  
  const variantStyles = {
    primary: { backgroundColor: '#f97316', color: 'white' },
    secondary: { backgroundColor: '#64748b', color: 'white' },
    success: { backgroundColor: '#10b981', color: 'white' },
    outline: { backgroundColor: 'transparent', color: '#f97316', border: '1px solid #f97316' },
  };
  
  const style = variantStyles[variant] || variantStyles.primary;
  
  return (
    <button
      onClick={handleExport}
      style={{
        padding: '8px 16px',
        borderRadius: '8px',
        border: style.border || 'none',
        backgroundColor: style.backgroundColor,
        color: style.color,
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.2s',
      }}
    >
      <span>{icon}</span> {label}
    </button>
  );
}

export default ExportButton;